import React from 'react';
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import { Typography, Button } from '@eventbrite/marmalade';

import styles from './PricingAndPackagingHeader.module.scss';

export const PricingAndPackagingHeader = () => {
    return (
        <div className={styles.header_div}>
            <div className={styles.pnp_heading}>
                <Typography
                    variant="heading-lg"
                    className={styles.heading}
                    as="h1"
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            "<span>Publish events for <span style='color:#D1410C;'>free</span> on the world's largest events marketplace</span>",
                        ).toString(),
                    }}
                />
                <Typography variant="body-lg" className={styles.text}>
                    {gettext(
                        'Our pricing is simple—publish your events for free, and attendees pay low cost Ticketing Fees only on paid tickets.',
                    )}
                </Typography>
                <Button
                    variant="primary"
                    size="responsive"
                    onClick={() => {
                        window.location.href = '/manage/events/create';
                    }}
                >
                    {gettext('Get started')}
                </Button>
            </div>
        </div>
    );
};

export default PricingAndPackagingHeader;
